var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWheel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4602 29.9891L27.4439 25.3501L12.5 16.7002V43.2797C12.5 46.8436 16.3493 49.0717 19.4294 47.2888L27.4439 42.6499L35.4602 38.0109C38.5403 36.2281 38.5403 31.7719 35.4602 29.9891ZM28.6824 35.4769L24.658 37.8064L20.6336 40.1358C19.4998 40.7928 18.0807 39.9711 18.0807 38.6571V26.3854L24.658 30.1918L28.6824 32.5212C29.8163 33.1782 29.8163 34.8199 28.6824 35.4769Z",
    fill: "#FC6621"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4602 21.896L32.0135 23.8848L12.5 12.5891V4.05093C12.5 2.53858 14.1376 1.5929 15.4483 2.34908L27.4439 9.27379L35.4602 13.8993C38.5403 15.6769 38.5403 20.1184 35.4602 21.896Z",
    fill: "#00B8B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheel);
export default __webpack_public_path__ + "static/media/wheel.84846c60c819656d4fb905a3c7640344.svg";
export { ForwardRef as ReactComponent };